import { invoke } from '../utils/apiClient';

/**
 * Get transaction data for signing
 */
export const getTransactionData = async (inquiryId, userAddress, token = null) => {
    try {
        const response = await invoke('POST', '/web3/identity/transaction-data', {
            inquiryId,
            userAddress
        }, { token });

        return response.data;
    } catch (error) {
        console.error('❌ Error getting transaction data:', error.message);
        throw error;
    }
};

/**
 * Save signed message
 */
export const saveSignedMessage = async (inquiryId, data, token = null) => {
    try {
        const response = await invoke('POST', '/web3/identity/save-signed-message', {
            inquiryId,
            data
        }, { token });

        return response.data;
    } catch (error) {
        console.error('❌ Error saving signed message:', error.message);
        throw error;
    }
};
